import React from "react";

const SelectableList = ({ items, selected, onToggle, emptyMessage, nameFor }) => {
  if (!items.length) return <div className="ql-exam-empty"><p>{emptyMessage}</p></div>;
  return (
    <div className="ql-exam-check-list">
      {items.map((item) => (
        <label key={item.id} className={selected.includes(item.id) ? "selected" : ""}>
          <input type="checkbox" checked={selected.includes(item.id)} onChange={() => onToggle(item.id)} />
          <span>{nameFor(item)}</span>
          <i className="bi bi-check-circle-fill" aria-hidden="true"></i>
        </label>
      ))}
    </div>
  );
};

const LoadingBlock = ({ text }) => (
  <div className="ql-exam-inline-state" role="status">
    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>{text}
  </div>
);

const ErrorBlock = ({ message, onRetry }) => (
  <div className="ql-exam-inline-state error" role="alert">
    <span>{message}</span>
    <button type="button" onClick={onRetry}>Réessayer</button>
  </div>
);

export default function ModuleLessonSelector({
  modules,
  lessons,
  selectedModules,
  selectedLessons,
  modulesLoading,
  lessonsLoading,
  modulesError,
  lessonsError,
  onToggleModule,
  onToggleLesson,
  onRetryModules,
  onRetryLessons,
  moduleValidationError,
}) {
  return (
    <section className="ql-exam-card" aria-labelledby="exam-program-title">
      <div className="ql-exam-card-heading">
        <span className="ql-teacher-eyebrow">Étape 2</span>
        <h2 id="exam-program-title">Modules et leçons</h2>
        <p>Sélectionnez le périmètre du programme utilisé pour la future épreuve.</p>
      </div>

      <div id="exam-module-list" className="ql-exam-selector-section" tabIndex="-1">
        <div className="ql-exam-selector-title"><h3>Modules *</h3><span>{selectedModules.length} sélectionné(s)</span></div>
        {modulesLoading ? <LoadingBlock text="Chargement des modules…" />
          : modulesError ? <ErrorBlock message={modulesError} onRetry={onRetryModules} />
            : <SelectableList items={modules} selected={selectedModules} onToggle={onToggleModule} emptyMessage="Aucun module disponible pour cette matière et cette classe." nameFor={(item) => item.name} />}
        {moduleValidationError && <span className="ql-exam-field-error">{moduleValidationError}</span>}
      </div>

      <div className="ql-exam-selector-section">
        <div className="ql-exam-selector-title"><h3>Leçons</h3><span>{selectedLessons.length} sélectionnée(s)</span></div>
        {selectedModules.length === 0 ? <div className="ql-exam-empty"><p>Sélectionnez au moins un module pour afficher ses leçons.</p></div>
          : lessonsLoading ? <LoadingBlock text="Chargement des leçons…" />
            : lessonsError ? <ErrorBlock message={lessonsError} onRetry={onRetryLessons} />
              : <SelectableList items={lessons} selected={selectedLessons} onToggle={onToggleLesson} emptyMessage="Aucune leçon n’est associée aux modules sélectionnés." nameFor={(item) => item.name} />}
        <small>La sélection de leçons reste facultative lorsque les modules définissent déjà le périmètre.</small>
      </div>
    </section>
  );
}
